import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import scrollPageToTop from '../utils/scrollPageToTop';

/* ScrollToTop — one place, every route.
 *
 * React Router keeps the window offset across navigate(). location.key changes on every
 * navigation (ProfileHome tiles, FooterNav — including a same-path tap that only changes
 * state — and browser back/forward), so each page starts at the top. Rendered once under
 * the Router in App.js; renders nothing.
 *
 * Pages built on .fr-tab-page scroll inside .fr-tab-content instead of the window (see
 * filterTemplate.css), so on those the TabBar is pinned regardless; this still resets the
 * window for ProfileHome, payments, training, contract and any page without that shell.
 */
export default function ScrollToTop() {
  const { key } = useLocation();
  useEffect(() => {
    scrollPageToTop(null);
  }, [key]);
  return null;
}
